exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, "figure {\n    width: 100%;\n    background-repeat: no-repeat;\n}\n\nfigure:hover #modal-image {\n    opacity: 0;\n}\n\n#modal-image {\n    display: block;\n    width: 100%;\n    pointer-events: none;\n}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"importLoaders":1}!./node_modules/postcss-loader/lib?{"ident":"postcss","plugins":[null,null]}!./src/assets/style/image.css
// module id = ./node_modules/css-loader/index.js?{"importLoaders":1}!./node_modules/postcss-loader/lib/index.js?{"ident":"postcss","plugins":[null,null]}!./src/assets/style/image.css
// module chunks = 0